import { db } from './db'

export default({
  prt: (msg, data) => {
    console.log(`comm.${msg}`, data)
  },
  trim(str) {
    if (str === undefined) return
    return str.replace(/(^\s*)|(\s*$)/g, '')
  },
  pkDbData(name, cbAct) {
    this.prt(`pkDbData.1`, name)
    new Promise((resolve, reject) => {
      db.ccStore.get(name).then((event) => {
        if (event && event.data/* && event.data --data==0时有问题 */) {
          cbAct ? cbAct(event.data) : resolve(event.data).then((rs) => {
            return rs
          })
        } else {
          this.prt(`pkDbData.4`, 'empty')
          cbAct('empty')
        }
      }).catch((rs) => {
        this.prt(`pkDbData.9.error`, rs)
      })
    })
  }, // 取缓存数据
  putDbData(name, data) {
    db.ccStore.put({ id: name, data: data })
  }, // 存缓存数据
  rmDbData() {
    window.localStorage.clear()
    db.imgStore.clear()
    db.ccStore.clear()
    console.log('已删除存储空间全部记录')
  }, // 清缓存
  mkColmns(datas) {
    // this.prt('mkColmns.1', datas)
    const tbClmn = []
    const finders = []
    const btns = []
    let colm = {}// this.arrPick(datas, 'fid', '0')//还得删掉
    // 找出标题行（fid=0）:
    try {
      datas.forEach((row, e) => {
        if (row.fid === '0') {
          colm = row
          datas.splice(e, 1)
          throw new Error('already found')
        }
      })
      return obj
    } catch (e) {
      // console.log(e)
    }
    // this.prt('mkColmns.2', colm)
    for (const row in colm) {
      const rowVal = colm[row]// [{'1,62,生产数量,0,0,12,1,1,0,0,0','0'}...]
      if ((rowVal + '.').indexOf(',') === -1) continue// 没标题的过掉
      const props = rowVal.split(',')
      if (props.length === 0) continue
      // 找出按钮:
      if (this.numIn(props[0], [2, 3])) { // buttons  ["1|新增"...]
        props.forEach((btnObj, e) => {
          if (e === 0) return
          if (btnObj.indexOf('|') > -1) {
            const btnStr = btnObj.split('|')
            btns.push({
              vkey: parseInt(btnStr[0]),
              vlabel: btnStr[1],
              vbox: this.toNum(props[0]) - 2
            })
          }
        })
        continue
      }
      let vfind = 0// 直接大于0的有序数字，或者：有序数字|标题
      let vfindtype = 0
      if (props.length > 4) {
        if (props[4].indexOf('|') > -1) {
          const finds = this.trim(props[4]).split('|')
          vfind = parseInt(finds[0])
          vfindtype = parseInt(finds[1])
        } else {
          vfind = parseInt(this.trim(props[4]))
        }
      }
      let vsort = props[1]
      let vsortey = props[1]
      if (props[1].indexOf('|') > -1) {
        const sorts = props[1].split('|')
        vsort = sorts[0]
        vsortey = sorts[1]
      }
      // 各个字段属性
      const or = {
        vkey: row, // 字段，fid,fcode...
        vbox: this.toNum(props[0]), // 0 head, 1 entry,
        vsort: this.toNum(vsort),
        vsortey: this.toNum(vsortey),
        vlabel: props[2], // 字段名
        vread: (this.toNum(props[3]) === 1), // when 1

        vfind: vfind, // this.trim(props[4]),
        vfindtype: vfindtype, // this.trim(props[4]),
        vwidth: this.trim(props[5]),
        vmust: this.toNum(props[6]) === 1, // when 1
        vvtype: this.toNum(props[7] || 6),

        vpurl: this.trim(props[8]), // path
        vpact: this.trim(props[9]), //
        vptype: this.trim(props[10]), // type
        vpkey: this.trim(props[11]),

        relate: this.trim(props[12]), // pick时的相关参数，如入库，源单的供应商
        bbMutip: this.toNum(props[14]) === 1,
        vhint: '',
        vhide: false,
        vhidey: this.numIn(this.toNum(props[0]), [6/* 状态*/]),
        vcaculate: props[16]
      }
      tbClmn.push(or)
      if (vfind > 0)finders.push(or)// ==1
    }// 处理字段行（标题）
    if (tbClmn.length > 0)tbClmn.sort(this.sortArr('vsort', true))
    if (finders.length > 0)finders.sort(this.sortArr('vfind', true))
    const obj = {
      colms: tbClmn,
      btns: btns,
      finders: finders,
      data: datas
    }
    return obj
  }, // 数据处理btns,cloms,datas
  pkEntrys(datas, fid) {
    const entrys = []
    datas.forEach(row => {
      if (row.fid === fid)entrys.push(row)
    })
    return entrys
  },
  ckMust(colms, row) {
    let msg = ''
    colms.forEach(colm => {
      if (colm.vbox === 0 && colm.must) {
        if (row[colm.vkey] && row[colm.vkey] !== '') { // row['fcode']
          return
        } else {
          msg += '请填写' + colm.label // /+ '\n<br>' + row[colm.vkey]
        }
      }
    })
    return msg
  },
  ckMustEy(colms, row, e) {
    let msg = ''
    colms.forEach(colm => {
      if (colm.must) {
        if (row[colm.vkey] && (row[colm.vkey].length > 0 || row[colm.vkey] > 0 || row[colm.vkey] !== '')) { //
          return
        } else {
          this.prt('ckMustEy', colm)
          msg += '请填写第' + (e + 1) + '行 ' + colm.label + '\n\r\t'
        }
      }
    })
    return msg
  },
  mkForm(files, fid, fidmenu, fidparent) {
    const frmData = new window.FormData()
    frmData.append('fid', fid)
    frmData.append('fidmenu', fidmenu)
    frmData.append('fidparent', fidparent)
    files.forEach(row => {
      frmData.append('upFiles', row)
    })
    return frmData
  },
  sortArr: (property, isAsc) => {
    return (firstobj, secondobj) => {
      const firstValue = firstobj[property]
      const secondValue = secondobj[property]
      if (isAsc) return firstValue - secondValue // 升序
      else return secondValue - firstValue
    }
  },
  arrSort: (iType, vkey, bbAsc) => { // iType:1/9.数字 6.字符
    return (aObj, bObj) => {
      const aVal = aObj[vkey]
      const bVal = bObj[vkey]
      if (iType === 1 || iType === 9) {
        if (bbAsc) return aVal - bVal // 升序
        else return bVal - aVal
      } else /* if (iType === 2) */ {
        const bbRs = (aVal.toLowerCase() > bVal.toLowerCase())
        if (bbAsc) {
          return bbRs ? 1 : -1
        } else {
          return bbRs ? -1 : 1
        }
      }
    }
  },
  base64File: (dataurl, filename) => {
    var arr = dataurl.split(',')
    var mime = arr[0].match(/:(.*?);/)[1]
    var bstr = atob(arr[1])
    var n = bstr.length
    var u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
  }, // base64转file
  mkTdHtml(row, colm) { // _delt2307 03_picker
    if (row[colm.vkey] === null) return ''
    if (parseInt(colm.vvtype) === 2) { // 2是状态
      if (row.estat) {
        if (row.estat === 221) return '已开工'
        else if (row.estat === 222) return '已完工'
        else if (row.fstat) {
          if (parseInt(row.fstat) === 1) return '已审'
          else if (parseInt(row.fstat) === 2) return '已完成'
          else return ''
        } else return ''
      }
    } else if (colm.vvtype === '0') { // 0是YN
      return row[colm.vkey] === '1' ? 'Y' : ''
    }/* else if (colm.vvtype === '3') {
      return this.dtUtil.dateFmt(row[colm.vkey], true)
    }*/
    return row[colm.vkey]
  },
  gType(typeId, iAct) {
    switch (typeId) {
      case 'ic':
        switch (iAct) {
          case 21:
            return '123'
        }
        break
      case 'prod':
        switch (iAct) {
          case 'pub':
            return '生产任务'
          case 'rpub':
            return '生产汇报'
        }
        break
    }
    return 'TASC移动管理平台'
  },
  pkIndex(tbClmn) {
    // this.prt('pkIndex.tbClmn', this.tbClmn)
    const rs = {
      dts: [],
      yns: [],
      ints: []
    }
    tbClmn.forEach((clmn, e) => {
      if (clmn.vvtype === '0') rs.yns.push(clmn.value)
      if (clmn.vvtype === '3') rs.dts.push(clmn.value)
      if (clmn.vvtype === '1' || clmn.vvtype === '2') rs.ints.push(clmn.value)
    })
    return rs
  },
  numIn(v, vs) {
    const vInt = parseInt(v)
    let rs = false
    vs.some(row => {
      if (vInt === row) {
        rs = true
        return true
      }
    })
    return rs
  },
  ssIn(v, vs) {
    return vs.findIndex(vv => v === vv) > -1
  },
  toAsc(v) {
    let vs = ''
    const vcnt = v.length
    for (let i = 0; i < vcnt; i++) {
      vs += (v.charCodeAt(i) * 102) + '9901'
    }
    return vs
  },
  mkBoxQty(row) {
    let fqty = row.fqty
    if (row.fstat > 5)fqty = row.fqtysend
    else if (row.fstat > 1)fqty = row.fqtyset
    // console.log('comm.mkBoxQty', row)
    if (row.fpqbox) {
      const fpqbox = parseInt(row.fpqbox)
      row.fqleft = fqty % fpqbox
      row.fqbox = (fqty - (fqty % fpqbox)) / fpqbox
      if (row.fpqsquare) row.fqsquare = (row.fqbox * row.fpqsquare).toFixed(4)
      if (row.fpqweight) row.fqweight = (row.fqbox * row.fpqweight).toFixed(4)
    }
  }, // 件数体积
  mkNum_delt24(val) {
    let newVal = 0
    if (val) {
      if (val !== '' || val !== undefined) {
        if (!isNaN(val)) {
          newVal = parseFloat(val)
        }
      }
    }
    return newVal
  },
  toNum(val) {
    if (!this.isVal(val)) return 0
    else if (isNaN(val)) return 0
    else return parseFloat(val)
  },
  toNumLocale(val) {
    return this.toNum(val).toLocaleString()// Number(13232.32).toLocaleString()//
  },
  mkNumTest(val) {
    this.prt('mkNum.1', val)
    let newVal = 0
    if (val) {
      if (val !== '' || val !== undefined) {
        if (!isNaN(val)) {
          newVal = parseFloat(val)
        }
      }
    }
    this.prt('mkNum.9', newVal)
    return newVal
  },
  isVal(val) {
    if (!val) return false
    if (val === undefined || val === null) return false
    if (val === '') return false
    return true
  },
  toVal(val) {
    if (!val) return ''
    if (val === undefined || val === null) return ''
    return val
  },
  pkErrMsg(val) {
    if (val === 'DupCode') return '单号重复'
    return ''
  },
  arrPick(arr, key, val) {
    try {
      let obj = {}
      arr.forEach((row, idx2) => {
        if (row[key] === val) {
          obj = row
          throw new Error('already found')
        }
      })// 找未有工号的行
      return obj
    } catch (e) {
      alert(e)
    }
  }
})



// WEBPACK FOOTER //
// ./src/utils/comm.js